import React from "react";

export default function DiscountBanner() {
  return (
    <section className="w-full bg-red-600 px-6 py-4 text-center text-xl font-extrabold text-white shadow-lg md:px-8 md:py-5 md:text-3xl">
      🎉 20 % Rabatt auf alles!
    </section>
  );
}
